/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { enviroment } from 'src/environments/environment';

export interface SolicitudCacheada {
  estado1: any;
  estado2: any;
}

@Injectable({
  providedIn: 'root',
})
export class ConsultaSolicitudService {
  private readonly solicitudesCache = new Map<number, SolicitudCacheada>();
  private readonly solicitudesEnCarga = new Set<number>();

  constructor(private httpClient: HttpClient) {}

  /**
   * Consulta solicitudes por beneficio_id, RUT y estado
   * @param beneficioId - ID del beneficio
   * @param rut - RUT del solicitante (formato: 13.715.564-8)
   * @param estadoSolicitudId - ID del estado de la solicitud (2 = Aprobada)
   * @returns Promise con la respuesta de solicitudes
   */
  async consultarSolicitudPorBeneficio(
    beneficioId: number,
    rut: string,
    estadoSolicitudId: number
  ): Promise<any> {
    const url = `${enviroment.url}consulta-solicitud/beneficio/${beneficioId}?rut=${rut}&estado_solicitud_id=${estadoSolicitudId}`;
    return firstValueFrom<any>(this.httpClient.get<any>(url));
  }

  /**
   * Realiza dos llamadas en paralelo (estado 1 y estado 2) para el beneficio
   * indicado y almacena los resultados en caché temporal.
   * Si ya existen datos en caché o hay una carga en curso para este beneficio,
   * omite las llamadas para evitar duplicados.
   */
  async precargarSolicitudesBeneficio(beneficioId: number, rut: string): Promise<void> {
    if (this.solicitudesCache.has(beneficioId) || this.solicitudesEnCarga.has(beneficioId)) {
      return;
    }
    this.solicitudesEnCarga.add(beneficioId);
    try {
      const [estado1, estado2] = await Promise.all([
        this.consultarSolicitudPorBeneficio(beneficioId, rut, 1),
        this.consultarSolicitudPorBeneficio(beneficioId, rut, 2),
      ]);
      this.solicitudesCache.set(beneficioId, { estado1, estado2 });
    } finally {
      this.solicitudesEnCarga.delete(beneficioId);
    }
  }

  /**
   * Devuelve los datos cacheados para un beneficio y estado dados.
   * Retorna null si aún no se han precargado.
   */
  obtenerSolicitudesCacheadas(beneficioId: number, estado: 1 | 2): any {
    const entrada = this.solicitudesCache.get(beneficioId);
    if (!entrada) return null;
    return estado === 1 ? entrada.estado1 : entrada.estado2;
  }

  /**
   * Elimina del caché los datos de un beneficio.
   */
  limpiarCacheBeneficio(beneficioId: number): void {
    this.solicitudesCache.delete(beneficioId);
  }
}
